import { InputCheckbox } from "@/components/base/input/input-checkbox";
import { Link } from "@/components/base/link";
import { HorizontalContainer } from "@/components/layout/horizontal-container";
import { VerticalSpacer } from "@/components/layout/vertical-spacer";
import { Text } from "@/components/ui/text";
import type { ChangeEvent } from "react";
interface TermsCheckboxProps {
  checked: boolean;
  id: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: string;
  linkText?: string;
  name: string;
  required?: boolean;
  url?: string;
}

export const TermsCheckbox = ({ checked, id, onChange, label, linkText, name, required, url }: TermsCheckboxProps) => (
  <>
    <InputCheckbox id={id} onChange={onChange} name={name} label={label} checked={checked} required={required} />
    <HorizontalContainer>
      <VerticalSpacer size="medium" />
      <VerticalSpacer size="x-small" />
      <VerticalSpacer size="x-small" />

      {url && linkText && (
        <Link href={url} newTab={true}>
          <Text size="small" value={linkText} />
        </Link>
      )}
    </HorizontalContainer>
  </>
);
